import React from 'react';
import { connect } from 'react-redux';

import {
    Backdrop,
    CircularProgress,
    Typography,
} from "@material-ui/core";

import ScrollContainer from "src/shared_modules/veu-visitors-core/components/common/container/scrollContainer";

import ReactHtmlParser from 'react-html-parser';
import dompurify from 'dompurify';

import {
    currentLanguage,
} from "src/shared_modules/i18n";

class GlobalPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading : true,
        }
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps, prevState) {

        if( prevProps.pageGlobal !== this.props.pageGlobal ) {

            console.warn("fooo ");

            if( this.props.pageGlobal === null ) {
                this.setState({isLoading: true});
            } else {
                this.setState({isLoading: false});
            }
        }
    }

    getValueForLang(obj, code2) {
        let val = obj.en.toString();
        if (obj[code2])
            val = obj[code2].toString();
        return val;
    }

    renderPage() {
        let lang = currentLanguage().code2;
        let page = this.props.pageGlobal;
        let title = this.getValueForLang(page.title, lang);
        let content = this.getValueForLang(page.content, lang);
        const sanitizer = dompurify.sanitize;

        return (<React.Fragment>
                <Typography variant="h4" component="h2" color="primary">
                    {title}
                </Typography>
                <ScrollContainer className="page">
                    <Typography variant="body1" component="div" color="primary">
                        {ReactHtmlParser(sanitizer(content)) }
                    </Typography>
                </ScrollContainer>
            </React.Fragment>);
    }

    render() {
        return (<React.Fragment>
                     { this.state.isLoading && <Backdrop className="inside-container" open={true} invisible={true}>
                        <CircularProgress />
                    </Backdrop> }
                    { !this.state.isLoading && this.renderPage() }
            </React.Fragment>);
    }
}

/*
 * ---------------------------------------------------------------------
 * StaticContent Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        currentLang: state.system.currentLang,
        pageGlobal: state.pages.pageGlobal,
    };
};
/*
* ---------------------------------------------------------------------
* Export the redux container
* ---------------------------------------------------------------------
*/
export default connect(
       mapStateToProps,
   )(GlobalPage);
